import {
  REQUEST_CUSTOMERS_PENDING,
  REQUEST_CUSTOMERS_SUCCESS,
  REQUEST_CUSTOMERS_FAILED,
  GET_CUSTOMER_PROFILE,
  GET_CUSTOMER_PROFILE_ERROR,
  EDIT_CUSTOMER_PROFILE_SUCCESS,
} from "../constants/customerConstants";

const initialStateCustomers = {
  customers: [],
  isPending: true,
};

export const requestCustomers = (
  state = initialStateCustomers,
  action = {}
) => {
  switch (action.type) {
    case REQUEST_CUSTOMERS_PENDING:
      return Object.assign({}, state, { isPending: true });
    case REQUEST_CUSTOMERS_SUCCESS:
      return Object.assign({}, state, {
        customers: action.payload,
        isPending: false,
      });
    case REQUEST_CUSTOMERS_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

const INITIAL_STATE = {
  customer: [],
  loading: true,
};
export const customer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_PROFILE:
      return {
        ...state,
        customer: action.payload,
        loading: false,
      };
    case GET_CUSTOMER_PROFILE_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const editCustomerProfile = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case EDIT_CUSTOMER_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        customer: action.payload,
      });
    default:
      return state;
  }
};
